import type { CrudAdapter } from '@botto/core';
import { useCrudDataSource } from '@botto/core';
import { smsClient } from '../client';
import type { MessageType, MessageTypeCreate, MessageTypeUpdate } from '../types';

export const messageTypesAdapter: CrudAdapter<MessageType, MessageTypeCreate, MessageTypeUpdate> = {
  async list({ offset, limit, sortName, sortDirection }) {
    const { data, error } = await smsClient.GET('/message_type/', {
      params: {
        query: {
          offset,
          limit,
          'sort.name': sortName ?? 'id',
          'sort.direction': (sortDirection ?? 'asc') as 'asc' | 'desc',
        },
      },
    });
    if (error) throw error;
    return { items: data?.items ?? [], total: data?.total ?? 0 };
  },
  async create(payload) {
    const { data, error } = await smsClient.POST('/message_type/', { body: payload });
    if (error) throw error;
    return { id: data?.id ?? 0 };
  },
  async update(payload) {
    const { data, error } = await smsClient.PUT('/message_type/', { body: payload });
    if (error) throw error;
    return (data ?? payload) as MessageType;
  },
  async byKey(id) {
    const { data, error } = await smsClient.GET('/message_type/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
    return data as MessageType;
  },
  async remove(id) {
    const { error } = await smsClient.DELETE('/message_type/{item_id}', {
      params: { path: { item_id: Number(id) } },
    });
    if (error) throw error;
  },
};

export const messageTypesStore = useCrudDataSource(messageTypesAdapter);
